import "./firebase";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./Home/Home";
import Auth from "./Auth/Auth";
import Privacy from "./Privacy/Privacy";
import Support from "./Support/Support";
import Eula from "./Eula/Eula";
import reportWebVitals from "./reportWebVitals";

import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/confirmemail",
    element: <Auth />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/eula",
    element: <Eula />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
